import {
    defaultShortNumberFormatter,
    LegendClickHandlers,
    MwChartGroupedColumnOptions,
    percentageFormatter
} from '@meltwater/mw-visualizations-angularjs';

import './chart_service.less';

'use strict';

function getPercentDeltaString({ seriesName, value, keyIndex }, series, label) {
    const seriesObjHover = series.filter(({ name }) => name === seriesName);
    const previousKeyIndex = Number(keyIndex) - 1;
    const previousValue = seriesObjHover[0].data[previousKeyIndex].value;
    let percentDeltaColor = 'mw-percent-delta__delta-value--delta-positive';
    let percentDeltaArrowDirection = 'mw-percent-delta__arrow-up';

    if(previousValue === value) {
        return `${label}: 0%`;
    }

    if(previousValue === 0 && value >= 0) {
        return `<div class="mw-percent-delta__delta-container">
                    ${label}:
                    <div class="mw-percent-delta__arrow ${percentDeltaArrowDirection}"></div>
                </div>`;
    }

    const percentDeltaValue = percentageFormatter(((value/previousValue)*100)-100);

    if(percentDeltaValue < 0) {
        percentDeltaColor = 'mw-percent-delta__delta-value--delta-negative';
        percentDeltaArrowDirection = 'mw-percent-delta__arrow-down'
    }

    return `<div class="mw-percent-delta__delta-container">
                ${label}:
                <div class="mw-percent-delta__arrow ${percentDeltaArrowDirection}"></div>
                <span class="mw-percent-delta__delta-value ${percentDeltaColor}">${percentDeltaValue}%</span>
            </div>`;
}

function shouldAnimateVisualization() {
    return !/wkhtmlto/i.test(navigator.userAgent);
}

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!
angular.module('MW.InsDashboard.ChartService', [
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.TranslationService',
    'MW.Framework.CoreCommon',
    'DashboardChartConfigService',
    'CoreColorService'
])
.factory('ChartService', [
    'InsWidgetConfigService',
    'translationService',
    'CoreCommon',
    'DashboardChartConfigService',
    'CoreColorService',
    '$filter',
    function (
        InsWidgetConfigService,
        translationService,
        CoreCommon,
        DashboardChartConfigService,
        CoreColorService,
        $filter) {

    var serviceObj;
    const DECIMAL_SEPARATOR = '.';
    const DEFAULT_DECIMAL_DIGITS = 0;
    const THOUSAND_SEPARATOR = ',';

    var getAreaGraph = function getAreaGraph(chartConfig){
        return createLineChart('normal', chartConfig);
    };

    var getLineGraph = function getLineGraph(chartConfig){
        return createLineChart(null, chartConfig)
    };
    var createLineChart = function createLineGraph(stacking, chartConfig){
        var chart;
        var YOYEnabled = (chartConfig.customSettings && chartConfig.customSettings.fetchDataForPreviousRange) ? chartConfig.customSettings.fetchDataForPreviousRange : false;

        var yAxisTitle = chartConfig.customSettings == null || typeof(chartConfig.customSettings.yAxisTitle) =='undefined' ? 'Count' : chartConfig.customSettings.yAxisTitle;

        var customData = {
            yAxis: {
                min : 0
            },
            plotOptions: {
                series: {
                    // If this is an area chart, stack. If it is a line chart, don't.
                    stacking: stacking,
                    point: {
                        events: {
                            click: function lineChartClick() {
                                chartConfig.drillDown(this.series.options.id, this.date, this.series.options.linkedTo);
                            }
                        }
                    },
                    dataLabels: {
                        enabled: chartConfig.dataLabels,
                        formatter: function() {
                            if(chartConfig.percentageMode) {
                                return DashboardChartConfigService.formatDataLabels(this.point.percent) + '%';
                            }
                            return DashboardChartConfigService.formatDataLabels(this.point.count);
                        }
                    },
                    pointPadding: 0
                }
            },
            legend:{
                enabled:true
            },
            tooltip: {
                shared: YOYEnabled,
                useHTML: YOYEnabled,
                formatter: function() {
                    if(YOYEnabled) {
                        if(this.points.length > 1)
                            var deltaPercent = ((this.points[0].point.count - this.points[1].point.count) / this.points[1].point.count) * 100;
                        var s = '<div class="comparison-tooltip">';
                        $.each(this.points, function(i, point) {
                            s += '<div class="date"><b>' + $filter('mwConvertDateToUserTimezone')(point.point.date, 'fullDate')  + '</b></div>'
                            + '<div><div class="point" style="color:'+ point.point.series.color +'">\u25CF</div>'
                            + '<div class="volume">' + translationService.getLocalizedString(yAxisTitle) + ' (#): ' + '</div>'
                            + '<div class="volume"><b>' + DashboardChartConfigService.formatDataLabels(point.point.count)
                            + '</b></div><div class="clearFix"></div></div>';
                        });
                        if(this.points.length > 1 && this.points[1].point.count > 0)
                            s += '<div class="change">'
                             + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + Highcharts.numberFormat(deltaPercent) + '%'
                             + '</div>';
                        s += '</div>'
                        return s;
                    } else {
                        var output = '<b>'+ this.series.name + '<br/>';
                        output += translationService.getLocalizedString(yAxisTitle) + ' (#): ' + Highcharts.numberFormat(Math.abs(this.point.count), 0) + ' / ' + Highcharts.numberFormat(this.point.percent) + '%';
                        if(this.point.indx > 0){
                            //get previous percentage
                            var previousData = this.series.data[this.point.indx - 1].y;
                            if(previousData > 0) { // GYDA-4537 - Cannot calculate a change percentage if your previous value is 0
                                var deltaPercent = ((this.point.y - previousData) / previousData)*100;
                                output += '<br/>' + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + ' ' + Highcharts.numberFormat(deltaPercent) +'%';
                            }
                        }
                        return output;
                    }

                }
            }
        };
        customData.tooltip.crosshairs = [];
        if(YOYEnabled) {
            customData.tooltip.crosshairs.push({
                enabled: false,
                color: CoreColorService.colors.grey5,
                dashStyle: 'solid',
                width: 1
            });
            customData.tooltip.borderColor = CoreColorService.colors.grey10
        }

        chart = CoreCommon.mergeRecursive(chartConfig.data, customData );

        if(chartConfig.view != 'max'){
            chart.xAxis = DashboardChartConfigService.getDashboardXAxisObject(chartConfig.data.xAxis.categories);
            /*
             * disable x axis legend when comparing date ranges
             */
            if (chartConfig.customSettings && chartConfig.customSettings.fetchDataForPreviousRange) {
                for (var i in chart.xAxis) {
                    chart.legend['margin'] = 12;
                    chart.xAxis[i]['labels'] = {
                        enabled: false
                    };
                }
            }
        }
        chart = createCustom(chart, chartConfig.custom);
        return chart;
    };

    var getBarGraph = function getBarGraph(chartConfig){
        var chart;
        var yAxisTitle = chartConfig.customSettings == null || typeof(chartConfig.customSettings.yAxisTitle) =='undefined' ? 'Share' : chartConfig.customSettings.yAxisTitle;
        var customData = {
            xAxis:{
                labels:{
                    useHTML: true
                },
                type:'category'
            },
            yAxis: {
                min : (chartConfig.percentageMode) ? 0 : null
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: chartConfig.dataLabels,
                        formatter: function() {
                            if(chartConfig.percentageMode)
                                return DashboardChartConfigService.formatDataLabels(this.point.percent) + '%';
                            return DashboardChartConfigService.formatDataLabels(this.point.count);
                        }
                    },
                    point: {
                        events: {
                            click: function barGraphClick() {
                                chartConfig.drillDown(this.id);
                            }
                        }
                    }
                }
            },
            tooltip: {
                formatter: function barGraphFormatter(){
                    var output = '<b>'+ this.point.name + '<br/>';
                    output += translationService.getLocalizedString(yAxisTitle) + ' (#): ' + Highcharts.numberFormat(Math.abs(this.point.count), 0) + ' / ' + Highcharts.numberFormat(this.point.percent) + '%';
                    return output;
                }
            }
        };
        chart = CoreCommon.mergeRecursive(chartConfig.data, customData );
        chart = createCustom(chart, chartConfig.custom);
        return chart;

    };

    var getDonutChart = function getDonutChart(chartConfig){
        var chart;

        var chartEvent = {
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            var label = '';
                            if(chartConfig.percentageMode)  {
                                label = DashboardChartConfigService.formatDataLabels(this.point.percent) + '%';
                            } else {
                                label = DashboardChartConfigService.formatDataLabels(this.point.count);
                            }
                            if(chartConfig.dataLabels) {
                                return this.point.name + ': ' + label;
                            } else {
                                return this.point.name;
                            }
                        }
                    },
                    point: {
                        events: {
                            click: function donutChartClick() {
                                chartConfig.drillDown(this.id);
                            }
                        }
                    }
                }
            }
        };
        chart = CoreCommon.mergeRecursive(chartConfig.data, chartEvent );

        chart = createCustom(chart, chartConfig.custom);
        return chart;
    };

    var createCustom = function createCustom(chart, customChart){

        //If a custom piece of the chart is passed in then apply it
        if(typeof customChart !== 'undefined') {
            chart = CoreCommon.mergeRecursive(chart, customChart );
        }

        return chart;
    };

    const getMwGroupedColumnOptions = (chartConfig) => {
        const config = {};
        const label = translationService.getLocalizedString('Change');
        let yAxisTitle = 'Share';

        if(typeof chartConfig.customSettings !== 'undefined' && typeof chartConfig.customSettings.yAxisTitle !== 'undefined') {
            yAxisTitle = chartConfig.customSettings.yAxisTitle;
        }

        config.yAxisTitle = translationService.getLocalizedString(yAxisTitle);

        if(chartConfig.colors.length > 0) {
            config.seriesColors = chartConfig.colors;
        }

        if (chartConfig.dataLabels) {
            config.dataLabelFormatter = ({value}) => `${defaultShortNumberFormatter(value)}`;
        }

        config.onPointClick = (event) => {
            const pointData = chartConfig.series[event.seriesIndex];
            chartConfig.drillDown(pointData.id, pointData.data[event.keyIndex].date);
        };

        if (chartConfig.view === 'user') {
            config.yAxisLabelFormatter = (options) => {
                if (options.isFirst || options.isLast) {
                    return defaultShortNumberFormatter(options.value);
                }
            };

            config.xAxisLabelFormatter = (options) => {
                if (options.isFirst || options.isLast) {
                    return options.value;
                }
            };
        }

        config.tooltipFormatter = (column) => {
            let percentDeltaLabel = '';
            if (column.keyIndex > 0) {
                percentDeltaLabel = getPercentDeltaString(column, chartConfig.series, label);
            }

            return `<b>${column.seriesName} (${column.key})</b><br/>
                ${translationService.getLocalizedString('Count')}: ${defaultShortNumberFormatter(column.value)}   <br/>
                ${percentDeltaLabel}`;
        };

        config.areDataLabelsVisible = chartConfig.dataLabels;
        config.onLegendClick = LegendClickHandlers.HIDE_SERIES;
        config.animate = shouldAnimateVisualization();

        return new MwChartGroupedColumnOptions(config);
    };

    serviceObj = {
        line: getLineGraph,
        column: getBarGraph,
        area: getAreaGraph,
        donut: getDonutChart,
        mwGroupedColumn: getMwGroupedColumnOptions
    };

    return serviceObj;

}]);
